import React from 'react';
import { Select } from 'antd';

export const GraphLayouts = [
	{
		label: 'Default',
		value: 'graphin-force'
	},
	{
		label: 'Circular',
		value: 'circular'
	},
	{
		label: 'Combo Combined',
		value: 'comboCombined'
	},
	{
		label: 'Combo Force',
		value: 'comboForce'
	},
	{
		label: 'Concentric',
		value: 'concentric'
	},
	{
		label: 'Dagre',
		value: 'dagre'
	},
	{
		label: 'Force',
		value: 'force'
	},
	{
		label: 'Force2',
		value: 'force2'
	},
	{
		label: 'Force Atlas',
		value: 'forceAtlas2'
	},
	{
		label: 'Fruchterman',
		value: 'fruchterman'
	},
	{
		label: 'GForce',
		value: 'gForce'
	},
	{
		label: 'MDS',
		value: 'mds'
	},
	{
		label: 'Radial',
		value: 'radial'
	},
	{
		label: 'Random',
		value: 'random'
	}
];

export interface GraphLayoutSelectorProps {
	onChange: (value: string) => void;
	value: string;
}

export const GraphLayoutSelector: React.FC<GraphLayoutSelectorProps> = (props) =>
	<Select
		options={ GraphLayouts }
		popupMatchSelectWidth={ false }
		{ ...props } />;
